<template>
  <div
    class="dropdown-options flex pl-12 pr-3 pb-8 pt-7"
    :class="isDropdown ? 'dropdown' : 'no-dropdown'"
  >
    <div v-if="showCities" class="w-60 flex flex-col">
      <h4>{{ $t("general.header.dropdown." + typeSection + ".cityTitle") }}</h4>
      <a
        v-for="city in navbarCityOptions"
        :key="city.id"
        :href="getUrl({ city })"
        class="option"
      >
        {{
          $t("general.header.dropdown." + typeSection + ".cityOption", {
            city: city.name
          })
        }}
      </a>
      <a v-if="!showGenres" class="show-more" :href="getUrl()">
        {{ $t("general.header.dropdown.showAll") }}
      </a>
    </div>
    <div v-if="showGenres" class="w-[16rem] flex flex-col">
      <h4>
        {{ $t("general.header.dropdown." + typeSection + ".genreTitle") }}
      </h4>
      <a
        v-for="genre in navbarGenresOptions"
        :key="genre.id"
        :href="getUrl({ genre })"
        class="option"
      >
        {{
          $t("general.header.dropdown." + typeSection + ".genreOption", {
            genre: genre.name
          })
        }}
      </a>
      <a class="show-more" :href="getUrl()">
        {{ $t("general.header.dropdown.showAll") }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { useGeneral } from "@/composables/useGeneral";
import { ROUTE_VALUES, DEFAULT_LANGUAGES } from "@/constants.js";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { slugConverter } from "@/plugins/slugConverter.js";

const { footerInfo, navbarInfo } = useGeneral();
const route = useRoute();
const langIndex = ref(0);
const languajes = ref(["es", "de", "en", "fr", "it", "pt"]);

const props = defineProps({
  typeSection: {
    type: String,
    required: true
  },
  showGenres: {
    type: Boolean,
    default: true
  },
  showCities: {
    type: Boolean,
    default: true
  },
  isDropdown: {
    type: Boolean,
    default: false
  }
});
onMounted(() => {
  let rect = document.getElementsByClassName("dropdown-options")[0];
  let theDiv = rect?.getBoundingClientRect();
  if (theDiv.bottom > window.innerHeight || theDiv.right > window.innerWidth) {
    if (rect) {
      rect.style.right = 0;
    }
  }
  let actualLang = DEFAULT_LANGUAGES[route.params.region || "es"];
  langIndex.value = languajes.value.findIndex(lang => lang === actualLang);
});
const navbarCityOptions = computed(() => {
  if (navbarInfo.value?.cities) {
    return navbarInfo.value.cities;
  } else {
    return footerInfo.value.cities;
  }
});
const navbarGenresOptions = computed(() => {
  if (navbarInfo.value?.genres) {
    return navbarInfo.value.genres;
  } else {
    return footerInfo.value.genres;
  }
});

const typeSectionStrings = computed(() => {
  if (props.typeSection === "concerts") {
    return ROUTE_VALUES.concertStrinigs;
  } else if (props.typeSection === "festivals") {
    return ROUTE_VALUES.festivalStrinigs;
  } else if (props.typeSection === "artists") {
    return ROUTE_VALUES.artistStrinigs;
  } else if (props.typeSection === "venues") {
    return ROUTE_VALUES.venueStrinigs;
  } else {
    return ROUTE_VALUES.pageStrinigs;
  }
});

const sendGa = label => {
  // if (this.$gtag && typeof this.$gtag.event === "function")
  //   this.$gtag.event("click", {
  //     event_category: label
  //   });
};

const getUrl = (filterData = {}) => {
  let url =
    "/" +
    (route.params.region || "es") +
    "/" +
    typeSectionStrings.value[langIndex.value];
  url +=
    "/geo/" +
    (navbarInfo.value?.country_slug ||
      footerInfo.value?.country_slug ||
      "espana");
  if (filterData.city) {
    url +=
      "/" +
      slugConverter(filterData.city.administrative_division.toLowerCase());
    if (filterData.city.slug) {
      url += "/" + filterData.city.slug;
    }
  } else if (filterData.genre) {
    url += "/gen/" + filterData.genre.slug;
  }
  return url;
};
</script>

<style scoped lang="scss">
.dropdown-options {
  background-color: $backgroundBlack;
  text-wrap: pretty;
  &.no-dropdown {
    margin-top: 33px;
    position: absolute;
  }
  &.dropdown {
    flex-direction: column;
    padding: 0px;
    padding-left: 24px;
    & > div {
      width: 100%;
      .option {
        padding-left: 0px;
        padding-right: 0px;
      }
      .show-more {
        text-align: left;
        display: block;
        margin-bottom: 20px;
      }
    }
  }
  &.no-dropdown {
    .show-more {
      text-align: right;
      display: block !important;
      color: $topaz;
      line-height: 30px;
      text-decoration: underline;

      margin-bottom: -28px !important;
      margin-right: 0px !important;
      margin-top: 28px !important;
    }
  }
  h4 {
    font-weight: 700;
    font-size: 15px;
    line-height: 40px;
  }
  a {
    margin: 0px;
  }
  .option {
    color: $textSubtitle;
    line-height: 30px;
  }
}
</style>
